<!-- Simplified Search Filters Panel - Single Line Layout -->
<div class="search-filters-panel" *ngIf="isVisible" >
  <div class="filters-inline-container" [formGroup]="filtersForm">
    <!-- Page Size Control -->
    <div class="filter-inline-item">
      <mat-form-field class="page-size-field">
        <mat-label>Page Size</mat-label>
        <mat-select formControlName="pageSize">
          <mat-option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-inline-item">
      <mat-form-field class="page-size-field">
        <mat-label>Max results</mat-label>
        <input matInput formControlName="maxResults" type="number" min="1" max="5000" />
      </mat-form-field>
    </div>

    <!-- Geofencing Control - mandatory for the embeddings API. Not gated by isSelectionDisabled$:
         changing it while a search is active is allowed, GeofencingSearchFilterService confirms
         with the user first since it clears the current results. -->
    <div class="filter-inline-item">
      <button matButton="elevated" *ngIf="!(geofencingValidation$ | async)?.valid" color="primary" (click)="openGeofencingDialog()">
        <mat-icon>crop_free</mat-icon>
        Add Geofencing Filter
      </button>
      <div *ngIf="(geofencingValidation$ | async)?.valid" class="d-flex align-items-center gap-2">
        <div matTooltip="Edit geofencing filter">
          <button matButton="elevated" color="primary" (click)="openGeofencingDialog()">
            <mat-icon>crop_free</mat-icon>
            Edit geofencing
          </button>
        </div>
        <div matTooltip="Remove geofencing filter">
          <button matButton="elevated" color="warn" (click)="removeGeofencingFilter()">
            <mat-icon>delete</mat-icon>
            Remove geofencing
          </button>
        </div>
      </div>
    </div>

    <!-- Geofencing area readout: red once the area is above what the API can process -->
    @if ((geofencingValidation$ | async); as geofencing) {
      <div class="filter-inline-item">
        <mat-chip-set>
          @if (geofencing.area) {
            <mat-chip [class.geofencing-area-chip--exceeded]="geofencing.area.exceedsLimit" [matTooltip]="geofencing.reason ?? ''">
              <mat-icon matChipAvatar>{{ geofencing.area.exceedsLimit ? "warning" : "straighten" }}</mat-icon>
              {{ geofencing.area.formatted }}
            </mat-chip>
          } @else if (!geofencing.valid) {
            <mat-chip [matTooltip]="geofencing.reason ?? ''">
              <mat-icon matChipAvatar>crop_free</mat-icon>
              Geofencing required
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    }
  </div>
</div>
